import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Header from './components/Banner/Header';
import ProfComponent from './components/Banner/ProfComponent';
import Clients from './components/Clients/Clients';
import Footer from './components/Footer/Footer';
import Projects from './components/Projects/Projects';
import Services from './components/Service/Services';
import FooterB from './components/Footer/FooterB';
import LoadingScreen from './components/Loding/LodingScreen';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const startTime = performance.now();

    window.onload = () => {
      const loadTime = performance.now() - startTime;
      if (loadTime) setLoading(false);
    };

    return () => {
      window.onload = null;
    };
  }, []);

  return (
    <Container>
      {loading ? (
        <div className="flex justify-center items-center min-h-screen" style={{minHeight:"100vh",display:"flex", justifyContent:"center", alignItems:"center" }}>
          <LoadingScreen />
        </div>
      ) : (
        <>
          <Banner>
            <Header />
            <ProfComponent />
          </Banner>
          <Services />
          <LightColor>
            <Projects />
          </LightColor>
          <Clients />
          <LightColor>
            <Footer />
          </LightColor>
          <FooterB />
        </>
      )}
      <ToastContainer />
    </Container>
  );
}

export default App;

const Container = styled.div``;

const Banner = styled.div`
  background: linear-gradient(159deg, rgb(45, 45, 58) 0%, rgb(43, 43, 53) 100%);
  height: 100vh;
  @media (max-width: 640px) {
    height: 100%;
    padding-bottom: 2rem;
  }
`;

const LightColor = styled.div`
  background: linear-gradient(159deg, rgb(45, 45, 58) 0%, rgb(43, 43, 53) 100%);
`;